<template>
  <LabelledInput
    v-if="enableSearchByLocation || enableFilterByCategory"
    label="Filtered bubble display"
    helpful-tip="Choose how to display bubbles that are excluded by filtering"
  >
    <LabelledInput>
      <div slot="label">
        <b-radio
          v-model="filterDisplayType"
          :value="HIDDEN"
        >
          Hide filtered bubbles
        </b-radio>
      </div>
    </LabelledInput>

    <LabelledInput>
      <div slot="label">
        <b-radio
          v-model="filterDisplayType"
          :value="TRANSLUCENT"
        >
          Translucent filtered bubbles
        </b-radio>
      </div>

      <LabelledInput
        label="Transparency"
        :disabled="filterDisplayType!==TRANSLUCENT"
      >
        <b-input-group>
          <b-input
            v-model="lightnessPercentage"
            type="number"
            min="0"
            max="100"
            step="1"
            style="max-width: 5em;"
          />
          <b-input
            v-model="lightnessPercentage"
            type="range"
            min="0"
            max="100"
            step="1"
          />
        </b-input-group>
      </LabelledInput>
    </LabelledInput>
  </LabelledInput>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

import { SEARCH_CONFIG_KEY, FILTER_BY_CATEGORY_KEY } from '@/constants'
import { FilterDisplayTypes } from '@/types'

const components = {
  LabelledInput,
}

@Component({ components })
export default class FilterDisplaySettings extends Vue {
  HIDDEN = FilterDisplayTypes.HIDDEN
  TRANSLUCENT = FilterDisplayTypes.TRANSLUCENT

  get enableSearchForProjects () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].enableSearchForProjects
  }

  set enableSearchForProjects (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'enableSearchForProjects'],
      value,
    })
  }

  get enableSearchByLocation () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].enableSearchByLocation
  }

  set enableSearchByLocation (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'enableSearchByLocation'],
      value,
    })
  }

  get enableFilterByCategory () {
    return this.$typedStore.primary.app.config[FILTER_BY_CATEGORY_KEY].enable
  }

  set enableFilterByCategory (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [FILTER_BY_CATEGORY_KEY, 'enable'],
      value,
    })
  }

  get filterDisplayType () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].filterDisplayType
  }

  set filterDisplayType (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'filterDisplayType'],
      value,
    })
  }

  get lightness () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].lightness
  }

  set lightness (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'lightness'],
      value,
    })
  }

  get lightnessPercentage () {
    return parseInt(`${(this.lightness - 0.5) / 0.5 * 100}`)
  }

  set lightnessPercentage (newValue) {
    this.lightness = newValue / 100 * 0.5 + 0.5
  }
}

</script>
